module.exports = {
      id: "login-google-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#login-google",
      toString: function () {
        return this.url;
      }
    }